// extracted by mini-css-extract-plugin
export default {"cardBoxSty":"StringPower_cardBoxSty__r5mRu"};